
import { initializeApp } from 'firebase/app';
import { fbAppConfigs } from '../../../project/appConfigs';
import { _projectAppNames, _useMeDb, envTypes } from '../../../project/appConfiguration';
import { fs_db } from '../../firestoreData/appData/fsAppData';
import { grts } from './reducerHelpers/dispatchProps';

const rts = {
  handleInit_database: 'handleInit_database',
  handleChange_database: 'handleChange_database',
  handleChange_databaseApp: 'handleChange_databaseApp',
  handleAmmend_refPaths: 'handleAmmend_refPaths',
  handleAmmend_appUserDbAccess: 'handleAmmend_appUserDbAccess',
  ...grts
}

export const databaseReducer = (state, action) => {

  let { type, app_state, projectAppName } = action ?? {}
  let { mainApp } = app_state ?? {}

  switch (type) {

    case rts.handleInit_database:

      const appName = _useMeDb ? _projectAppNames.meetingevolution : _projectAppNames.pojo
      const _appName = appName

      let _environment;

      switch (_appName) {
        case _projectAppNames.meetingevolution:
          switch (document.location.host) {
            case 'mobile.events.meetingevolution.net':
              _environment = 'prod'
              break;
            default:
              _environment = 'dev'
          }
          break;

        case _projectAppNames.thumbstat:
        case _projectAppNames.cardnudge:
        case _projectAppNames.pojo:
          _environment = 'dev'
          break;
        default:
      }

      const _fsdb = fs_db(mainApp).get_fsAlt(mainApp)
      return { ...state, fsdb: _fsdb, fsdbName: _appName }

    case rts.handleChange_databaseApp:
      return { ...state, useProdDb: action.prodOverrideOn }

    case rts.handleChange_database:

      let _environment_change;

      switch (projectAppName) {
        case _projectAppNames.meetingevolution:
        case _projectAppNames.thumbstat:
        case _projectAppNames.cardnudge:
        case _projectAppNames.pojo:
          _environment_change = 'dev'
          break;
        default:
      }

      const _config_change = fbAppConfigs[projectAppName][_environment_change]
      const fsInit_change = initializeApp(_config_change, projectAppName)
      const fsdb_change = fs_db.get_fsAlt(fsInit_change)

      return { ...state, fsdb: fsdb_change, fsdbName: projectAppName }

    case rts.handleAmmend_refPaths:
      const _refPaths = [...state.refPaths]
      _refPaths.push(action.refPath)
      return { ...state, refPaths: _refPaths }

    case rts.handleAmmend_appUserDbAccess:
      const { appUserDbAccess } = action
      const { accessLevel, loggedIn, isSuperAdmin, uid, displayName } = appUserDbAccess ?? {}
      const dbAccess = {
        accessLevel,
        loggedIn,
        isSuperAdmin,
        uid,
        displayName,
      }
      return { ...state, appUserDbAccess: dbAccess }

    default:
      return { ...state }
  }
}

export const databaseHandlers = (dispatch) => {
  return {
    handleChange_database: (projectAppName) => { dispatch({ type: rts.handleChange_database, dispatch, projectAppName }) },
    handleChange_databaseApp: (prodOverrideOn) => { dispatch({ type: rts.handleChange_databaseApp, dispatch, prodOverrideOn }) },
    handleInit_database: (app_state) => { dispatch({ type: rts.handleInit_database, dispatch, app_state }) },
    handleAmmend_refPaths: (refPath) => { dispatch({ type: rts.handleAmmend_refPaths, dispatch, refPath }) },
    handleAmmend_appUserDbAccess: (appUserDbAccess) => { dispatch({ type: rts.handleAmmend_appUserDbAccess, dispatch, appUserDbAccess }) },
  }
}

export const databaseInitialState = (initState) => {
  return { ...initState, refPaths: [] }
};

const isDev_me = () => {
  if (document.location.host.indexOf('mobiledev') >= 0 ||
    document.location.host.indexOf('me-mobile-4410b') >= 0) {
    return true
  } else {
    return false
  }
}

export const isMeProd = () => {
  // return true
  switch (process.env.NODE_ENV) {
    case envTypes.production:
      if (isDev_me()) {
        return false
      } else if (document.location.host.indexOf('mobile') >= 0) {
        return true
      } else {
        return false
      }
    default:
      return false
  }
}
